/**
 * @generated SignedSource<<a62488b710204414b7506c6f6b82f14e>>
 * @relayHash db2d1f908b60e0f0367a6df20e4fc4fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 24411ab7ab7c1d36801a2dea89e46f32dc4d7d18f77a59f22c4492969c58317a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ArchiveProjectModalQuery } from './ArchiveProjectModalQuery.graphql';

const node: PreloadableConcreteRequest<ArchiveProjectModalQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "24411ab7ab7c1d36801a2dea89e46f32dc4d7d18f77a59f22c4492969c58317a",
    "metadata": {},
    "name": "ArchiveProjectModalQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
